/**
 * Created by yiren on 2019-08-29
 * vote page
 */

import React from "react";
import style from "./style.css";
import { Toast, List } from "antd-mobile";
import { contractCall, getAccountState } from "../config/api";
import nebulas from "nebulas";
import { getContractAddress, getFromAddress } from "../tool/lstool";
import QRCode from "qrcode.react";
import NebPay from "nebpay.js";

const { Item } = List;
const { Brief } = Item;

export default class VoteProposal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contractAddress: getContractAddress(),
      fromAddress: getFromAddress()
    };
    this.nebPay = new NebPay();
    this.serialNumber = "";
  }

  componentDidMount() {
    if (!this.state.contractAddress || !this.state.fromAddress) {
      Toast.info("请先设置合约地址以及From");
      this.props.history.push('/contract');
    }

    this.getApprovedProposal();
  }

  async getApprovedProposal() {
    Toast.loading();
    try {
      let proposalArray = [];

      let param = `{"from":"${this.state.fromAddress}","to":"${this.state.contractAddress}","value":"0","gasPrice":"20000000000","gasLimit":"2000000","contract":{"function":"getAwaitTransferProposal","args":"[]"}}`;
      console.log(param);
      const data = await contractCall(JSON.parse(param));
      console.log(data);

      if (data.result.result == "{}") {
        Toast.info("列表为空", 1);
        return;
      }

      let info = JSON.parse(data.result.result);

      for (let index in info) {
        proposalArray.push(info[index]);
      }

      this.setState({
        openProposal: proposalArray
      });
      this.setList(proposalArray);
      console.log(info);
      Toast.hide();
    } catch (e) {
      Toast.hide();
      console.log(e);
    }
  }

  proceedAction = index => {
    this.getAccountInfo(index);
    console.log("START", index);
  };

  async getAccountInfo(index) {
    Toast.loading();
    const data = await getAccountState({
      address: this.state.fromAddress
    });
    if (data.result) {
      console.log(data.result);
      this.setState({
        accountInfo: data.result
      });
      this.generateVoteTransaction(index);
    } else {
      Toast.hide();
    }
  }

  generateVoteTransaction = index => {
    let param = [index];
    let paraStr = JSON.stringify(param);
    console.log("STR = " + paraStr);
    var tx = {
      chainID: 1,
      from: this.state.fromAddress,
      to: this.state.contractAddress,
      value: 0,
      nonce: this.state.accountInfo.nonce,
      gasPrice: 20000000000,
      gasLimit: 200000,
      contract: {
        function: "startTransferForProposal",
        args: paraStr
      }
    };
    console.log(tx);
    this.setState({
      txString: JSON.stringify(tx),
      index: index
    });

    Toast.hide();
    // console.log(tx.hashTransaction())
  };

  nebpayAction = () => {
    const to = `${this.state.contractAddress}`; //Dapp的合约地址
    const value = "0";
    const callFunction = "startTransferForProposal"; //调用的函数名称
    const callArgs = `["${this.state.index}"]`; //参数格式为参数数组的JSON字符串, 比如'["arg"]','["arg1","arg2]'
    const options = {
      gasLimit: "200000", //可以自定义gasLimit和gasPrice
      //callback 是交易查询服务器地址,
      //callback: NebPay.config.mainnetUrl //在主网查询(默认值)
      callback:
        process.env.API_ENV === "prod"
          ? NebPay.config.mainnetUrl
          : NebPay.config.testnetUrl //在测试网查询
    };

    //发送交易(发起智能合约调用)
    this.serialNumber = this.nebPay.call(
      to,
      value,
      callFunction,
      callArgs,
      options
    );

    console.log(this.serialNumber);
  };

  setList = list => {
    let ItemList = [];
    for (let index in list) {
      let keys = Object.keys(list[index].vote);
      let voters = "";
      for (let i in keys) {
        let str = keys[i].slice(-5);
        voters = voters + str + ": ";

        if (list[index].vote[keys[i]] == "0") {
          voters = voters + "NO  ";
        } else {
          voters = voters + "YES  ";
        }
      }

      ItemList.push(
        <Item>
          <div className={style.cellContainer}>
            <div className={style.indexContainer}>
              <span
                className={style.textSpanBold}
              >{`Index ${list[index].index}`}</span>
            </div>
            <div className={style.middleContainer}>
              <div>
                <span className={style.textSpan}>Amount:</span>{" "}
                <span
                  className={style.textSpanBold}
                >{`${list[index].amount}`}</span>{" "}
                <span className={style.textSpan}>To Address:</span>{" "}
                <span
                  className={style.textSpanBold}
                >{` ${list[index].toAddress}`}</span>
              </div>
              <div style={{ marginTop: "10px" }}>
                <span className={style.textSpan}>Voted By:</span>
                <span className={style.textSpan}>{`${voters}`}</span>{" "}
              </div>
              <div>
                <span
                  className={style.textSpan}
                >{`Notes: ${list[index].note}`}</span>
              </div>
              <div>
                <button
                  className={style.agreeButton}
                  onClick={this.proceedAction.bind(this, list[index].index)}
                >
                  执行转账
                </button>
              </div>
            </div>
            <div className={style.rightContainer}>
              <span
                style={
                  list[index].status == "Declined"
                    ? { color: "red" }
                    : { color: "black" }
                }
              >
                {list[index].status}
              </span>
            </div>
          </div>
        </Item>
      );
    }

    this.setState({
      list: ItemList
    });
  };

  render() {
    const params = `{"pageParams":{"pay":{"currency":"NAS","value":"0","to":"${this.state.contractAddress}","payload":{"function":"startTransferForProposal","args":"[\\"${this.state.index}\\"]","type":"call"}}},"des":"confirmTransfer","category":"jump"}`;

    return (
      <div className={style.container}>
        <h2>执行转账</h2>
        <div
          style={{
            width: "100%",
            height: "1px",
            backgroundColor: "rgba(0,0,0,0.6)"
          }}
        />
        <div>
          <div>
            <List style={{ backgroundColor: "rgb(243,243,248)" }}>
              {this.state.list}
            </List>
          </div>
          <div>
            {this.state.txString ? (
              <div className={style.txContainer}>
                <p>{this.state.txString}</p>
              </div>
            ) : (
              false
            )}

            {this.state.txString ? (
              <div>
                <p><b>使用Nas Nano Pro 扫码</b></p>
                <QRCode value={params} size={150} />
              </div>
            ) : (
              false
            )}

            {this.state.txString ? (
              <div>
                <p><b>使用Nas Wallet Extension</b></p>
                <button
                  className={style.agreeButton}
                  onClick={this.nebpayAction}
                >
                  发起交易
                </button>
              </div>
            ) : (
              false
            )}
          </div>
        </div>
      </div>
    );
  }
}
